import { render, staticRenderFns } from "./CrudTable.vue?vue&type=template&id=c8ee1fbc"
import script from "./CrudTable.vue?vue&type=script&lang=js"
export * from "./CrudTable.vue?vue&type=script&lang=js"
import style0 from "./CrudTable.vue?vue&type=style&index=0&id=c8ee1fbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports